import React, { useState, useEffect } from "react";
import moment from "moment-timezone";
import Dropdown from "../../common/components/dropdown";
import Pagination from "../../common/components/pagination";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { DateRange } from "react-date-range";
import { useNavigate, useLocation } from "react-router-dom";
import ClickOutside from "../../common/components/clickOutside";
import Utils from "../../utility";
import { keyConstants } from "../../constants";
import { IoMdArrowUp, IoMdArrowDown } from "react-icons/io";

const List = ({
  list,
  totalPages,
  currentPage,
  handlePageChange,
  handleFirstPage,
  handleLastPage,
  loading,
  resultFilter,
  setDebouncedSearch,
  setResultFilter,
  feedbackFilter,
  setFeedbackFilter,
  setDate,
  selectTime,
  setSelectTime,
  createdOnSortBy,
  setCreatedOnSortBy,
  setProcessedOnSortBy,
  processedOnSortBy,
  date,
  topRef,
  setCurrentPage,
  // versions,
  setSelectedVersion,
  // selectedVersion,
  processedDate,
  setProcessedDate,
  selectProcessedTime,
  setSelectProcessedTime,
  withinSLA,
  setWithinSLA,
  withHours,
  setWithHours,
  sort,
  setSort,
  debounce,
  versionScope,
  setVersionScope
}) => {
  const [open, setOpen] = useState(false);
  const [openProcessed, setOpenProcessed] = useState(false);
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const [searchClaim, setSearchClaim] = useState("");
  const [hover, setHover] = useState("");
  const [selectedRow, setSelectedRow] = useState(
    Number(sessionStorage.getItem("selectedRow")) || null
  );
  const [range, setRange] = useState({
    startDate: date?.startDate ? new Date(date?.startDate) : null,
    endDate: date?.endDate ? new Date(date?.endDate) : new Date(""),
    key: "selection"
  });
  const isWithoutFeedback =
    queryParams.get("questionText") ||
    queryParams.get("reportFeedback") ||
    queryParams.get("feedbackType") ||
    queryParams.get("report") ||
    queryParams.get("slaCompliance") ||
    queryParams.get("processedWithinSLA");
  const details = queryParams.get("details");
  const [rangeProcessed, setRangeProcessed] = useState({
    startDate: processedDate?.startDate
      ? new Date(processedDate?.startDate)
      : null,
    endDate: processedDate?.endDate
      ? new Date(processedDate?.endDate)
      : new Date(""),
    key: "selection"
  });

  const navigate = useNavigate();
  const handleDateSelect = (ranges) => {
    const { startDate, endDate } = ranges.selection;

    const formattedStartDate = Utils.formatDateYear(startDate);
    const formattedEndDate = Utils.formatDateYear(endDate);

    setRange({
      ...range,
      startDate: ranges.selection.startDate,
      endDate: ranges.selection.endDate
    });

    setDate((prev) => ({
      ...prev,
      startDate: formattedStartDate,
      endDate: formattedEndDate
    }));
    setCurrentPage(1);
  };

  const handleSelect = (value) => {
    setSelectTime(value);
    if (value === "Custom") {
      setOpen(true);
    } else {
      setOpen(false);
    }
  };

  const handleDateSelectProcessed = (ranges) => {
    const { startDate, endDate } = ranges.selection;

    const formattedStartDate = Utils.formatDate(startDate);
    const formattedEndDate = Utils.formatDate(endDate);

    setRangeProcessed({
      ...rangeProcessed,
      startDate: ranges.selection.startDate,
      endDate: ranges.selection.endDate
    });

    setProcessedDate((prev) => ({
      ...prev,
      startDate: formattedStartDate,
      endDate: formattedEndDate
    }));
    setCurrentPage(1);
  };
  const handleSelectProcessed = (value) => {
    setSelectProcessedTime(value);
    if (value === "Custom") {
      setOpenProcessed(true);
    } else {
      setOpenProcessed(false);
    }
  };

  const handleCreatedSort = () => {
    setCreatedOnSortBy((prevOrder) => (prevOrder === "asc" ? "desc" : "asc"));
    setSort("createdOn");
  };
  const handleProcessedSort = () => {
    setProcessedOnSortBy((prevOrder) => (prevOrder === "asc" ? "desc" : "asc"));
    setSort("processedOn");
  };

  const handleSearch = (e) => {
    const value = e.target.value ?? "";
    setSearchClaim(value);

    const searchIsEmpty = value.trim() === "";
    setSelectProcessedTime(searchIsEmpty ? "Last 14 days" : "All");
  };
  const handleClearFilters = () => {
    setSelectTime("All");
    setResultFilter("All");
    setFeedbackFilter("All");
    setSearchClaim("");
    setDebouncedSearch("");
    setRange({
      startDate: new Date(),
      endDate: new Date(),
      key: "selection"
    });
    setSelectProcessedTime("Last 14 days");
    setSelectedVersion("All");
    setCurrentPage(1);
    setSelectedVersion("Latest");
    // setSort("");
  };

  const handleFeedbackText = (feedback) => {
    switch (feedback) {
      case keyConstants.CORRECT:
        return "Correct";
      case keyConstants.GEN_AI_CORRECT_INSUFFICIENT_INPUTS:
        return "Correct (As Per Input & Rules)";
      case keyConstants.INCORRECT_AI_RESPONSE:
        return "Incorrect AI response";
      case keyConstants.INCORRECT_DATA_IMAGE:
        return "Incorrect data image";
      default:
        return "-";
    }
  };

  useEffect(() => {
    if (isWithoutFeedback || details) {
      setSelectProcessedTime(selectProcessedTime);
    }
    if (searchClaim !== "") {
      const handler = setTimeout(() => {
        setDebouncedSearch(searchClaim);
        setCurrentPage(1);
      }, 600);

      return () => clearTimeout(handler);
    } else {
      setDebouncedSearch("");
    }

    // eslint-disable-next-line
  }, [searchClaim]);

  useEffect(() => {
    if (debounce) setSearchClaim(debounce);
  }, []);

  const userTZ = Intl.DateTimeFormat().resolvedOptions().timeZone;

  return (
    <div className="h-full">
      <div className="flex  flex-wrap justify-between">
        <div className="flex flex-wrap items-center gap-2 pl-2.5">
          <img
            onClick={() => {
              if (isWithoutFeedback && !details) {
                navigate(-1);
              } else {
                navigate("/claim-list");
              }
            }}
            src="/images/left-arrow.svg"
            alt=""
            className="cursor-pointer"
          />

          <span className="font-InterBold text-ft25-30 text-black-10">
            Claims
          </span>
          <div className="ml-3 flex h-10 w-55 items-center gap-2 rounded-lg border  border-grey-10 bg-white p-3">
            <img
              src="/images/search-safe-guard.svg"
              alt="searchIcon"
              className="size-5 opacity-60"
            />
            <input
              type="text"
              placeholder="Claim Search"
              value={searchClaim}
              onChange={handleSearch}
              className="w-full bg-transparent font-InterRegular text-ft14-17 text-black-0 placeholder:text-grey-20 focus:outline-none"
            />
          </div>
          <ClickOutside isOpen={open} onClickOutside={() => setOpen(false)}>
            <div className="relative">
              <Dropdown
                width={"min-w-30"}
                text={"Date"}
                value={selectTime}
                list={["All", "Last 14 days", "Previous month", "Custom"]}
                handleSelect={handleSelect}
                setOpenCalendar={setOpen}
                startDate={date?.startDate}
                endDate={date?.endDate}
              />
              {open && (
                <div className="absolute z-[999]">
                  <DateRange
                    ranges={[range]}
                    onChange={handleDateSelect}
                    className="rounded-md border border-grey-30"
                    showDateDisplay={false}
                    showMonthAndYearPickers={false}
                  />
                </div>
              )}
            </div>
          </ClickOutside>
          <ClickOutside
            isOpen={openProcessed}
            onClickOutside={() => setOpenProcessed(false)}
          >
            <div className="relative">
              <Dropdown
                width={"min-w-30"}
                text={"Processed"}
                value={selectProcessedTime}
                list={["Last 14 days", "Previous month", "Custom"]}
                handleSelect={handleSelectProcessed}
                setOpenCalendar={setOpenProcessed}
                startDate={processedDate?.startDate}
                endDate={processedDate?.endDate}
              />
              {openProcessed && (
                <div className="absolute z-[999]">
                  <DateRange
                    ranges={[rangeProcessed]}
                    onChange={handleDateSelectProcessed}
                    className="rounded-md border border-grey-30"
                    showDateDisplay={false}
                    showMonthAndYearPickers={false}
                  />
                </div>
              )}
            </div>
          </ClickOutside>
          <Dropdown
            width={"w-31"}
            text={"Within Time"}
            value={withinSLA}
            list={["All", "Yes", "No"]}
            handleSelect={setWithinSLA}
            setCurrentPage={setCurrentPage}
          />
          <Dropdown
            width={"w-31"}
            text={"Within Working Hours"}
            value={withHours}
            list={["All", "Yes", "No"]}
            handleSelect={setWithHours}
            setCurrentPage={setCurrentPage}
          />
          <Dropdown
            width={"w-31"}
            text={"Processing Status"}
            value={resultFilter}
            list={[
              "Open",
              "InProgress",
              "Success",
              "Failed",
              "NoTireComponents"
            ]}
            handleSelect={setResultFilter}
            setCurrentPage={setCurrentPage}
          />
          <Dropdown
            width={"min-w-31"}
            text={"Feedback"}
            value={feedbackFilter}
            list={[
              "All",
              "Incorrect AI response",
              "Incorrect data/image",
              "Correct",
              "Correct (As Per Input & Rules)"
            ]}
            handleSelect={setFeedbackFilter}
            setCurrentPage={setCurrentPage}
          />
          {/* {isWithoutFeedback && ( */}
          <Dropdown
            width={"min-w-31"}
            text={"Version Scope"}
            value={versionScope}
            list={["Latest", "All"]}
            handleSelect={setVersionScope}
            setCurrentPage={setCurrentPage}
          />
          {/* )} */}
          <div
            className="flex cursor-pointer items-center gap-1"
            onClick={handleClearFilters}
          >
            <span className="font-InterRegular text-ft14-17 text-blue-10">
              Clear
            </span>
            <img src="/images/clear.svg" alt="" />
          </div>
          <div className="ml-10 flex gap-3">
            {/* <div
            onClick={() => navigate("/commercial-report")}
            className="flex h-10 cursor-pointer items-center justify-center rounded-lg border border-grey-10 p-3"
          >
            <span className="font-InterRegular text-ft14-17 ">
              Show Commercial Usage
            </span>
          </div> */}

            {!isWithoutFeedback && (
              <div
                onClick={() => navigate("/inspection-claims/report")}
                className="flex h-10 cursor-pointer items-center justify-center rounded-lg border border-grey-10 p-3"
              >
                <span className="font-InterRegular text-ft14-17 ">
                  Show Inspection Report
                </span>
              </div>
            )}
            <div
              onClick={() => navigate("/repair-claims")}
              className="flex h-10 cursor-pointer items-center justify-center rounded-lg border border-grey-10 p-3"
            >
              <span className="font-InterRegular text-ft14-17 ">
                Repair Claims Override Decision
              </span>
            </div>
          </div>
        </div>
      </div>

      {loading ? (
        <div className="flex h-80vh items-center justify-center">
          <div className="loader "></div>
        </div>
      ) : list?.length > 0 ? (
        <div>
          <div
            ref={topRef}
            className=" mt-10 max-h-75vh w-full  overflow-y-auto"
          >
            <table className="w-full">
              <thead>
                <tr className="sticky top-0  z-10 w-full bg-white font-InterBold text-ft10-18.15 text-black-10">
                  <td className="pb-2.5 pl-2.5">Claim Number</td>
                  <td>Version</td>
                  {/* <td>Contract Number</td> */}
                  <td>
                    <div
                      className="flex cursor-pointer gap-1"
                      onClick={handleCreatedSort}
                      onMouseEnter={() => setHover("createdOn")}
                      onMouseLeave={() => setHover("")}
                    >
                      <span className="font-InterBold text-ft10-18.15  text-black-10">
                        Created On
                      </span>
                      {createdOnSortBy === "asc" && sort === "createdOn" ? (
                        <IoMdArrowDown />
                      ) : (
                        sort === "createdOn" && <IoMdArrowUp />
                      )}
                      {hover === "createdOn" &&
                        createdOnSortBy !== "asc" &&
                        sort !== "createdOn" && <IoMdArrowDown />}
                    </div>
                  </td>

                  <td>
                    <div
                      onClick={handleProcessedSort}
                      onMouseEnter={() => setHover("processedOn")}
                      onMouseLeave={() => setHover("")}
                      className="flex cursor-pointer gap-1"
                    >
                      <span className="font-InterBold text-ft10-18.15  text-black-10">
                        Processed On
                      </span>
                      {processedOnSortBy === "asc" && sort === "processedOn" ? (
                        <IoMdArrowDown />
                      ) : (
                        sort === "processedOn" && <IoMdArrowUp />
                      )}
                      {hover === "processedOn" &&
                        processedOnSortBy !== "asc" &&
                        sort !== "processedOn" && <IoMdArrowDown />}
                    </div>
                  </td>
                  <td>Within Time</td>
                  <td>Actual - Expected Time </td>
                  <td>Processing Status</td>
                  <td>Within Working Hours</td>
                  <td>Feedback</td>
                </tr>
              </thead>
              <tbody>
                {list.map((item, idx) => {
                  const diffInSeconds = (
                    (item.processingEndTime - item.processingStartTime) /
                    1000
                  ).toFixed(2);
                  return (
                    <tr
                      onClick={() => {
                        setSelectedRow(idx);
                        sessionStorage.setItem("selectedRow", idx);

                        sessionStorage.setItem(
                          "scrollPosition",
                          topRef.current.scrollTop
                        );

                        const params = new URLSearchParams(search || "");

                        params.set("version", item?.version || 1);

                        navigate({
                          pathname: `/inspection-claims/${item?.claimNumber}`,
                          search: `?${params.toString()}`
                        });
                      }}
                      key={idx}
                      className={`cursor-pointer border-t border-grey-30  ${idx === selectedRow ? "bg-grey-10 bg-opacity-[.2]" : "hover:bg-grey-10 hover:bg-opacity-[.2]"}`}
                    >
                      <td className="w-10per py-3.5 pl-2.5 font-InterRegular text-ft10-18.15 text-black-10">
                        {item.claimNumber}
                      </td>
                      <td className="w-5per font-InterRegular text-ft15-18 text-black-10">
                        v{item?.version}
                      </td>
                      {/* <td className="w-10per font-InterRegular text-ft15-18 text-black-10">
                        {item.contractNumber}
                      </td> */}
                      <td className="w-15per font-InterRegular text-ft15-18 text-black-10">
                        {item.createdDateTime
                          ? moment
                              .tz(item.createdDateTime, "America/New_York")
                              .tz(userTZ)
                              .format("DD MMM YYYY h:mm A")
                          : "-"}
                      </td>

                      <td className="w-15per font-InterRegular text-ft15-18 text-black-10">
                        {item.processingEndTime
                          ? moment(item.processingEndTime).format(
                              "DD MMM YYYY h:mm A"
                            )
                          : "-"}
                      </td>
                      <td className="w-10per font-InterRegular text-ft15-18 text-black-10">
                        {item.processedWithinSLA ? "Yes" : "No"}
                      </td>

                      <td className="w-15per font-InterRegular text-ft15-18 text-black-10">
                        {diffInSeconds}s -{" "}
                        {item?.repairFirstCheck?.expectedCompletionSeconds ||
                          "0"}
                        s{" "}
                      </td>

                      <td className="w-15per">
                        {item?.claimProcessingStatus && (
                          <div
                            className={`${
                              item.claimProcessingStatus.toLowerCase() ===
                              "success"
                                ? " bg-green-10 bg-opacity-[.2] text-green-10"
                                : item.claimProcessingStatus?.toLowerCase() ===
                                    "failed"
                                  ? "bg-red-20 text-red-10"
                                  : "bg-grey-100 bg-opacity-[.5] text-black-20 text-opacity-[.8]"
                            } w-max rounded-full  px-2.5 py-1 font-InterMedium text-ft14-17 `}
                          >
                            {Utils.convertCamelCaseToSentence(
                              item.claimProcessingStatus
                            )}
                          </div>
                        )}
                      </td>
                      <td className="w-15per font-InterRegular text-ft15-18 text-black-10">
                        {item.isEventPublishedInWorkingHours
                          ? "Yes"
                          : item.isEventPublishedInWorkingHours === false
                            ? "No"
                            : "-"}
                      </td>
                      <td className="w-20per">
                        {handleFeedbackText(item?.feedback)}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            handleFirstPage={handleFirstPage}
            handleLastPage={handleLastPage}
            handlePageChange={handlePageChange}
          />
        </div>
      ) : (
        <div className="flex h-80 items-center justify-center">
          <span className="font-InterBold text-ft24-32 text-black-0">
            No data found
          </span>
        </div>
      )}
    </div>
  );
};

export default List;
